import $ from "jquery";

$(function(){
  $('.tabs-container li').on('click', function(){
    $(this).addClass('active').siblings('.active').removeClass('active');
    let idTabContent = $(this).attr('data-tab');
    $('.tab-news-content.active').removeClass('active');
    $('#' + idTabContent).hide().addClass('active').fadeIn(300);
  })
});



// WEBPACK FOOTER //
// ./resources/assets/js/tabs.js